import React from "react";
import Ship from "./svg/ship.svg";
import Butler from "./svg/butler.svg";
import World from "./svg/world.svg";
import Shorex from "./svg/shorex.svg";
import Experience from "./svg/experience.svg";
import { match } from "ts-pattern";

type Props = {
  iconName: string;
  className?: string;
  alt?: string;
};

const ColoredIcon: React.FC<Props> = ({ iconName, className, alt }) => {
  const svg = match(iconName)
    .with("colored-ship", () => Ship)
    .with("colored-butler", () => Butler)
    .with("colored-world", () => World)
    .with("colored-shorex", () => Shorex)
    .with("colored-experience", () => Experience)
    .otherwise(() => undefined);

  if (!svg) return null;

  return (
    <img src={svg} alt={alt || iconName} className={className} aria-hidden />
  );
};

export default ColoredIcon;
